import DataDownlinkTransmissionModal from './data-downlink-transmission-modal.vue'
export default DataDownlinkTransmissionModal
